import { reducerKey } from './RcsSupplierInfoReducer';

// eslint-disable-next-line import/prefer-default-export
export function rcsSupplierInfo(state) {
  return state.get(reducerKey);
}
